import React, { useEffect, useState } from 'react'

import { useAxios } from '../../utilities/Requests/useAxios'

export interface PassportResponseObj {
  peerGroupsHours: number
  groupHourRequirement: number
  providerAppointmentHours: number
  providerHourRequirement: number
  totalHourRequirement: number
  totalHours: number
}

export interface PassportEncouragementTextObj {
  text: string
  isDoingWell: boolean
}

export interface PassportContextInterface {
  getPassportRecord: (patientId: number) => Promise<PassportResponseObj>
  passportResponse: PassportResponseObj
}

export const PassportContext =
  React.createContext<PassportContextInterface | null>(null)

export const PassportProvider = ({ children }: any) => {
  const { fetch } = useAxios()

  const [timezoneStr, setTimezoneStr] = useState<string | null>('')

  const getTimezoneId = async () => {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      setTimezoneStr(timezone)
    } catch (error) {
      return 'error getting timezone' // Fallback to UTC if there's an error
    }
  }

  useEffect(() => {
    getTimezoneId()
  }, [])

  const [passportResponse, setPassportResponse] = useState<PassportResponseObj>(
    {
      groupHourRequirement: 0,
      peerGroupsHours: 0,
      providerAppointmentHours: 0,
      providerHourRequirement: 0,
      totalHourRequirement: 0,
      totalHours: 0,
    }
  )

  const getPassportRecord = async (patientId: number) => {
    try {
      const { data } = await fetch({
        path: `MyPassport/GetMyPassportData?timezone=${timezoneStr}&patientId=${patientId}`,
      })
      setPassportResponse(data)
      return data
    } catch (error) {
      console.log('Error Getting Passport Record: ', error)
    }
  }

  return (
    <PassportContext.Provider
      value={{
        getPassportRecord,
        passportResponse,
      }}
    >
      {children}
    </PassportContext.Provider>
  )
}
